export const LOAD_USERS = 'LOAD_USERS'
export const RECEIVE_USERS = 'RECEIVE_USERS'